export enum ElementType {
  INPUT,
  RICHTEXT
}
